import {
  BasketItem,
  KnownBasketItemPaymentMethodType,
} from '@modules/checkout-store';

export interface IBasketItemWithDescription extends BasketItem {
  description: string;
  title: string;
  ticketType: string;
  paymentMethodType: KnownBasketItemPaymentMethodType;
  isDirectDebit: boolean;
  alias: string;
  subtitle: string;
  termDateFrom: string;
  termDateTo: string;
}
